import imga from '@/imgs/dynamica.png'
import imgg from '@/imgs/dynamicg.png'
import imgp from '@/imgs/dynamicn.png'
import imgr from '@/imgs/dynamicp.png'
import imgs from '@/imgs/dynamicq.png'
import imgx from '@/imgs/dynamicv.png'
import imgy from '@/imgs/dynamicw.png'
import imgz from '@/imgs/dynamicx.png'
import imgu from '@/imgs/dynamics.png'
import interone from '@/imgs/business/Likwid.png'
import intertwo from '@/imgs/business/Minsave.png'
import interthree from '@/imgs/business/Minspend.png'
import advantageone from '@/imgs/business/01.png'
import advantagetwo from '@/imgs/business/02.png'
import advantagethree from '@/imgs/business/03.png'
import advantagefour from '@/imgs/business/04.png'
import advantagefive from '@/imgs/business/05.png'
import advantagesix from '@/imgs/business/06.png'
import homeworldimg from '@/imgs/bannerworden.png'
import pcmapen from '@/imgs/pcmapen.png'
export default {
  navs: [
    {text: 'Home', jump: '/homeWeb'},
    {text: 'Products', jump: '/intelligent'},
    // {text: 'News', jump: 'http://news.mintechai.com/'},
    {text: 'About Us', jump: '/aboutus'}
  ],
  leftnavs: {
    a: 'Global Strategy',
    b: 'Global Partners'
  },
  pchome: {
    homeone: {
      imgword: homeworldimg
    },
    hometwo: {
      a: 'Phoenix',
      b: 'San Diego',
      c: 'Washington D.C.',
      d: 'Beijing',
      e: 'Yangzhou',
      f: 'Shanghai',
      g: 'Shenzhen',
      h: 'Manila',
      i: 'Jakarta',
      j: 'Global Strategy',
      k: '',
      imgurl: pcmapen

    },
    homethree: {
      a: 'Shareholders',
      b: '',
      redtext: 'Founded in Silicon Valley in 1999, Redpoint was one of the first venture capital firms that entered China. It has invested in more than 382 companies globally and 121 of them have successfully completed an IPO or M&A.',
      gaodetext: 'Amap is the leading provider of digital maps, GPS, and location services in China. In January 2017, MinTech closed series B funding with Mr. Chen Chongwu, a founder of Amap, as its initial investor.',
      hongtaitext: 'AngelPlus is a venture capital firm  co-founded by widely recognized educator Mr. Yu Minghong, and senior investing banker Mr. Shen Xitai. It is the single largest RMB angel funds in China at present.'
    },
    homefour: {

    }
  },
  inteligent: {
    title: {
      a: 'Global Full-service ',
      b: 'Digital',
      c: 'Banking Platform'
    },
    partone: {
      title: 'Our</br>Business',
      intro: 'Mintech is building a one-stop full-service digital banking platform to grow with millennial globally, and provides a variety of services including credit card, saving, loan, payment, e-commerce to meet millennial’s diverse needs at different stages of their life.',
      partlist: [
        {
          imgurl: interone,
          name: 'Likwid'
        },
        {
          imgurl: intertwo,
          name: 'Minsave'
        },
        {
          imgurl: interthree,
          name: 'Minspend'
        }
      ]
    },
    parttwo: {
      title: 'Comparative Advantages',
      partlist: [
        {
          imgurl: advantageone,
          name: 'One-stop Financial Service Platform'
        },
        {
          imgurl: advantagetwo,
          name: 'Secured with Resources and Funding'
        },
        {
          imgurl: advantagethree,
          name: 'Local Operation Teams in Multiple Countries'
        },
        {
          imgurl: advantagefour,
          name: 'Large Customer Base'
        },
        {
          imgurl: advantagefive,
          name: 'Streamlined Online + Offline Coverage'
        },
        {
          imgurl: advantagesix,
          name: 'Modularized System Platform for Flexible Deployment'
        }
      ]
    },
    partthree: {
      title: 'R&D Capability',
      partlist: [
        {
          name: 'Artificial Intelligence',
          text: 'With heavy investment in R&D, we made significant breakthrough in machine learning, natural language processing, biometric authentication and knowledge graph, and delivered successful application in various business scenarios such as customer acquisition, risk control, anti-fraud, underwriting decision-making, and collection management.'
        },
        {
          name: 'Big Data',
          text: 'We provide services to commercial banks and Internet companies by leveraging big data analytics, and create values for enterprises by improving forecast accuracy, optimizing pricing, enhancing customer experience, and strengthening risk management.'
        },
        {
          name: 'Cloud Computing',
          text: 'We created a hybrid cloud platform based on container technology and DevOps principles. The platform is oriented to micro-service applications, and greatly simplifies system deployment, security, monitoring, expansion, and upgrade.'
        }
      ]
    }
  },
  newsbanner: ['/newsEni', '/newsEnl', '/newsEnc'],
  newslist: [
    {
      imgurl: imgx,
      title: 'MinTech Brand Upgrade, Redefine Itself with Technology',
      content: `On September 6, MinTech successfully held 2018 MinTech Brand Upgrade Press Conference with the theme "Convergence Creates Future" in Shanghai, China, which unveiled the company's five business sectors and all new image for the first time.`,
      timeone: 'Sep-6',
      timetwo: '2018',
      origin: 'Chinese.org',
      jump: '/newsEni'
    },
    {
      imgurl: imgy,
      title: 'WinDigital MinTech Fund is established to support fintech start-ups',
      content: 'At its brand upgrade conference on September 6, MinTech officially announced the establishment of WinDigital MinTech Fund in cooperation with Beijing WinDigital Fund.',
      timeone: 'Sep-6',
      timetwo: '2018',
      origin: 'China',
      jump: '/newsEnj'
    },
    {
      imgurl: imgz,
      title: 'MinTech and Nova Promote "Credit Pearl River Delta"',
      content: 'On September 6, MinTech Co-founder and CEO Mickey Li and Nova Credit Limited CEO Jiayi He officially signed a strategic cooperation agreement.',
      timeone: 'Sep-6',
      timetwo: '2018',
      origin: 'Finance Net',
      jump: '/newsEnk'
    },
    {
      imgurl: imgu,
      title: 'Mint Quantum became a member of the National Internet Finance Association of China (NIFA)',
      content: 'On July 30th, Beijing Mint Quantum Information Technology Co., Ltd. (Hereinafter referred to as “Mint Quantum”) officially became a member of the National Internet Finance Association of China (NIFA). ',
      timeone: 'Jul-30',
      timetwo: '2018',
      origin: 'Finance Net',
      jump: '/newsEnl'
    },
    {
      imgurl: imga,
      title: 'Mint Quantum Won "The 2018 Most Influential Brand of the Internet Finance Industry"',
      content: 'In the past two years, Mint Quantum has won a number of awards, and has gained recognition in both the market and reputation.',
      timeone: 'Mar-21',
      timetwo: '2018',
      origin: 'Finance Net',
      jump: '/newsEng'
    },
    {
      imgurl: imgg,
      title: 'The 2017 Yunqi Conference Was Held    Case Study of Mint Quantum Becoming Alibaba’s Cloud Customer Receives Recognition',
      content: 'The ‘Intelligent Quantum Cloud’ system was unveiled at the Yunqi Conference. Because of its outstanding performance in cloud computing and cloud security, the system, together with Nanjing City Commercial Bank and JUMEI, were used by Alibaba Cloud as an outstanding customer case study in the field of finance.',
      timeone: 'Dec-22',
      timetwo: '2017',
      origin: 'China Economic Net ',
      jump: '/newsEne'
    },
    {
      imgurl: imgp,
      title: 'The Financial Technology Security Community Makes Concerted Efforts for Saftey.Mint Quantum and Other Industry Leaders Build an Information Security Defense',
      content: 'Mint Quantum’s CTO Donghui Shao was invited to attend the first member conference of the Financial Technology Security Community.',
      timeone: 'Nov-29 ',
      timetwo: '2017',
      origin: 'Global Times',
      jump: '/newsEnd'
    },
    {
      imgurl: imgr,
      title: 'China Business News Pundit’s choice: Mint Quantum Won "The 2017 Most Outstanding Competitor in Pioneering AI Technology Award"',
      content: 'According to China Business News, China has become the second largest economy in the world, and the Chinese finance industry has taken on an important responsibility.',
      timeone: 'Nov-23',
      timetwo: '2017',
      origin: 'SOHU',
      jump: '/newsEnh'
    },
    {
      imgurl: imgs,
      title: 'Mint Quantum’s Yinghao Li Believes: The Online Chinese Credit Business Model Can Be Applied Overseas.',
      content: 'Smart credit has become a global trend, and Mint Quantum wants to be the first to export its technology overseas.',
      timeone: 'Sep-4 ',
      timetwo: '2017',
      origin: 'Bai Jiahao ',
      jump: '/newsEnf'
    }
  ],
  companyNews: {
    a: 'Content',
    b: 'Media Partners',
    c: 'From'

  },
  joinus: {
    title: 'Join us'
  },
  aboutus: {
    bannertext: {
      a: 'About MinTech',
      b: 'Mintech is building a one-stop full-service digital banking platform to grow with millennial globally, and provides a variety of services including credit card, saving, loan, payment, e-commerce to meet millennial’s diverse needs at different stages of their life and to make financial services accessible to everyone.',
      c: 'Headquartered in Singapore, Mintech, with its technology capability and expertise in financial services, has launched its business in China, the United States, Germany, Indonesia, the Philippines, India and Brazil, and established strategic partnerships with diverse global companies such as Wirecard, Telkomsel, LinkAja.',
      d: 'The core team comes from top financial institutions such as Capital One, Citi Group, Credit Suisse, IMF, HSBC, Bank of America, Amex, etc., The team has extensive experience in international market and access to important business resources.'
    },
    bossinfo: {
      one: {
        a: 'Mickey Li',
        b: 'Co-founder & CEO',
        c: 'Cornell University, MBA',
        d: 'University of Georgia, M.S.',
        e: 'Renmin University of China, B.S. in International Economics',
        f: 'Mr. Li was a Data Scientist at Capital One, SVP at Citigroup Global Risk Management Division, Executive Advisor to President at China Guangfa Bank, and Chief Risk Officer at Nasdaq-listed company Rong-360. He has 20 years of experience in consumer finance, retail credit and small & micro credit industries across different countries.',
        g: 'Mr. Li has been a visiting professor of Renmin University of China since 2013 and a guest lecturer of Tsinghua PBCSF since 2017. With a focus on innovation and development in fintech, he was selected as the Hurun New Financial Industry Person of the Year in 2018.',
        h: ''
      },
      two: {
        a: 'Leo Zhao',
        b: 'Co-founder & Chairman',
        c: 'Tsinghua University，PBC School of Finance, EMBA',
        d: 'University of Miami, M.S. and Ph. D',
        e: 'Nanjing University, Department of Intensive Instruction, B.S.',
        f: 'Dr. Zhao served as the director at Capital One and led high profile product and marketing campaigns with coverage of 60 million customers. He also worked at Credit Suisse investment bank division at New York headquarter office. During his tenure in Credit Suisse, he was in charge of multi-billions investment projects in emerging markets and accumulated extensive investment and financial experiences.',
        g: 'Along with his successful career track, Dr. Zhao is an experienced entrepreneur. He founded Quantum Info in New York in 2007 and NeoSource in Washington D.C. in 2010. Dr. Zhao was member of the 11th leadership program at AAMA , and one of the first scholars of the Tsinghua-Qingteng Future Technology Leader School.'
      },
      three: {
        a: 'Yi Liu',
        b: 'Co-founder & COO',
        c: 'University of Pennsylvania, M.S. and Ph.D Candidate in Economics',
        d: 'Tsinghua PBCSF, M.S in International Finance',
        e: "Mr. Liu started his professional career at the People's Bank of China in Beijing, and later worked at IMF in Washington D.C. He worked at Capital One for ten years for multiple positions, and led the acquisition and integration of HSBC's U.S. credit card portfolio.",
        f: 'With 20 years of experience in consumer finance and credit industry, Mr. Liu has extensive expertise in customer operations and financial IT projects.'
      },
      four: {
        a: 'Denis Kalinin',
        b: 'Head of AI',
        c: 'Focused on scalable tech solutions',
        d: 'Finstar Financial Group Head of Business Development: 3 years',
        e: 'Sberbank Technologies CEO: 2 years',
        f: 'Nuclear Physics Institute: 4 years. Worked at MIR Space Station & on International Space Station projects'
      },
      five: {
        a: 'Susan Feeney',
        b: 'VP International Business Development',
        c: 'Focused on consumer financial services in Europe',
        d: 'Bank of America EVP European Market Expansion and BBD: 5 years',
        e: 'MBNA SVP Marketing for Insurance Start-Ups & CMO of MBNA Spain: 11 years',
        f: ''
      },
      six: {
        a: 'Glenn Quiro',
        b: 'Vice Chairman',
        c: 'Electrical Engineering, UC Los Angeles',
        d: 'Glenn was a 14 year Intel Veteran, managing products and organizations both in United States and China. He was Product Director for Intel Greater China Region, and General Manager of Intel Shenzhen and Intel Shanghai. His experience cuts across all segments of technologies and all business verticals.',
        e: 'Glenn’s expertise includes servers, PC and mobile, and IOT. Prior to Intel, he held management positions at Galileo Technology, Altera Corporation, and Cypress Semiconductors in Silicon Valley.',
        f: 'His global exposure across most continents, profound knowledge of technology and internet, and deep understanding of financial products provide solid foundation in fintech innovation and partnership.'
      },
      seven: {
        a: 'Mindy Nian',
        b: 'Overseas Business COO & CRO',
        c: 'Ph.D., Applied Economics, Clemson University',
        d: 'Bachelor’s degree in International Economics, Xiamen University',
        e: 'Dr. Nian was the Head of Data Science at Capital One Bank’s Big Data Transformation & Payments Department. During her 11-year tenure at Capital One, Dr. Nian developed broad expertise on consumer credit risk management, and deep knowledge in cutting edge decisioning models and technologies, and played a critical role in Capital One’s big data transformation across all consumer and small business segments.',
        f: 'Dr. Nian also served as Senior Product Owner and Model Risk Officer for big data products and models for Capital One’s card business. After returning from the USA, Dr. Nian worked as CRO in Qudian Group and COO in Quantgroup. As a well-recognized risk management expert, she joined MinTech as global CRO.'
      }
    },
    bossintr: 'Management Team',
    history: 'Development',
    historyText: {
      aa: '10/2015',
      a: 'Mint Quantum Set up Its Headquarters in China',
      bb: '12/2015',
      b: 'Mint Quantum Set up Its Researching Lab in Silicon Valley',
      cc: '5/2016',
      c: 'Mint Quantum Closed Series A Funding',
      dd: '1/2017',
      d: 'Mint Quantum Closed Series B Funding',
      ee: '7/2017',
      e: 'Mint Quantum Set up Subsidiary in Indonesia',
      ff: '12/2017',
      f: 'Mint Quantum Set up Subsidiary in Philippines',
      gg: '9/2018',
      g: 'MinTech Brand Promotion'
    },
    honor: 'Awards',
    trophy: {
      a: 'Best Application of Big Data Risk Management',
      aa: '--Yibencaijin',
      b: '2018 Most Influential Internet Finance Brand',
      bb: '--Consumption Daily',
      c: 'Fintech Company of the Year',
      cc: '--2018 HuRun FinTech top 100 list',
      d: '2017 Most Promising Company Award',
      dd: "--2017 China's most influential Fintech List",
      e: 'Best FinTech Company of 2017',
      ee: '--Daily Economic News',
      f: 'The 2017 Outstanding Pioneer in AI Technology Award',
      ff: '--China Business Newspaper',
      g: '2016-2017 Best FinTech Award',
      gg: '--Economic Observer Newspaper',
      h: 'The 2017 New Force in Internet Finance Award',
      hh: '--Baidu Finance Summit',
      i: '2017 XFZ Innovative Startup Round Table ',
      ii: '--XFZ',
      j: 'Best FinTech Startup Company',
      jj: '--Hunting cloud network',
      k: 'The 2017 Most Potential FinTech ',
      kk: 'CEO leader annual conference committee',
      l: "2017 China's Best R&D FinTech Company",
      ll: '--CCID',
      m: 'Joint Initiative of Fulfilling Financial Responsibility.',
      mm: '--Finance City',
      n: 'Pioneering FinTech Company of the Year',
      nn: '--China Consumer Newspaper',
      o: '2017 Outstanding Contribution to Fintech Award ',
      oo: 'Internet Weekly',
      p: ' Member of the Fintech Community',
      pp: 'FinTech Security Community',
      q: 'The 2017 Consumer Finance Risk Management Award',
      qq: '--RongZhiJia',
      r: 'Source Plan - Asia Star',
      rr: '--Asia Chamber of Business',
      s: 'Zhongguancun High Tech Company',
      ss: '--Zhongguancun Technology Park Management Committee',
      t: 'Certification of "New Technology and New Technology Products in Beijing',
      tt: '--Zhongguancun Technology Park Management Committee'
    }
  },
  footer: {
    a: 'Join us',
    b: 'Jobs : hr_zhaopin@mintechai.com',
    c: 'Business Partnership : bd_marketing@mintechai.com',
    d: 'Copyright©2019北京铭泰金科信息技术有限公司 | 京ICP备18045888号',
    e: 'Media Inquiries : ',
    f: 'pr@mintechai.com'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js